/* eslint-disable import/no-anonymous-default-export */


import {
    LOGIN,
    LOGOUT,
    REGISTER,
    GET_USER,
    GET_ALL_USERS,
    GET_ALL_USERS_PAGE,
    ADD_ROLE,
    ADD_PERMISSION,
    LOGIN_ERROR,
    LOGOUT_ERROR,
    REGISTER_ERROR,
    ADD_ROLE_ERROR,
    ADD_PERMISSION_ERROR,
    GET_USER_ERROR,
    GET_ALL_USERS_ERROR,
    GET_ALL_ADVERTISEMENTS_PAGE_ERROR,
    GET_ALL_USERS_PAGE_ERROR,
    UPDATE_IMAGE_ERROR,
    UPDATE_ACCOUNT_PROFILE,
    UPDATE_ACCOUNT_PROFILE_ERROR,
} from "../actions/types";

const initialState = {
    accountUser: null,
    accountUserRoles: null,
    isAuthenticated: null,
    token: localStorage.getItem("token"),
    users: null,
    
    
    isLoading: true,
    success: false,
};

export default function (state = initialState, action) {
    const { payload, type } = action;

    switch (type) {

    case UPDATE_ACCOUNT_PROFILE:
        localStorage.setItem("token", payload.token);
        return {
            ...state,
            accountUser: {
                id: payload.updatedUser.id,
                email: payload.updatedUser.email,
                name: payload.updatedUser.firstName,
                title: payload.updatedUser.title,
                lastName: payload.updatedUser.lastName,
                bio: payload.updatedUser.bio,
                image: payload.updatedUser.image,
                userId: payload.updatedUser.userId,
                role_id: payload.updatedUser.role_id,
                permissions: payload.updatedUser.Role.Permissions,
                hasAccess: payload.updatedUser.Role.Permissions.map(permission => permission.permission)
            },
            isAuthenticated: true,
            token: payload.token,
            accountUserRoles: payload.updatedUser.Role,
            isLoading: false,
            success: true,
        };

        case LOGIN:
        localStorage.setItem("token", payload.token);
            return {
                ...state,
                accountUser: {
                    id: payload.user.id,
                    email: payload.user.email,
                    name: payload.user.firstName,
                    title: payload.user.title,
                    lastName: payload.user.lastName,
                    bio: payload.user.bio,
                    image: payload.user.image,
                    userId: payload.user.userId,
                    role_id: payload.user.role_id,
                    permissions: payload.user.Role.Permissions,
                    hasAccess: payload.user.Role.Permissions.map(permission => permission.permission)
                },
                isAuthenticated: true,
                token: payload.token,
                accountUserRoles: payload.user.Role,
                isLoading: false,
                success: true,
            };
        case GET_USER:
            return {
                ...state,
                accountUser: {
                    id: payload.id,
                    email: payload.email,
                    name: payload.firstName,
                    title: payload.title,
                    lastName: payload.lastName,
                    bio: payload.bio,
                    image: payload.image,
                    userId: payload.userId,
                    role_id: payload.role_id,
                    permissions: payload.Role.Permissions,
                    hasAccess: payload.Role.Permissions.map(permission => permission.permission)
                },
                isAuthenticated: true,
                accountUserRoles: payload.Role,
                isLoading: false,
                success: true,
            };
        case GET_ALL_USERS_PAGE:
        case GET_ALL_USERS:
            return {
                ...state,
                users: payload,
                isLoading: false,
                success: true,
            };
        case GET_ALL_USERS_PAGE_ERROR:
        case GET_ALL_USERS_ERROR:
            return {
                ...state,
                users: payload,
                isLoading: false,
                success: false,
            };
        case LOGOUT:
        case GET_USER_ERROR:
            localStorage.getItem("token");
            localStorage.removeItem("token");
            return {
                ...state,
                token: null,
                accountUserRoles: null,
                user: null,
                isAuthenticated: false,
                success: false,
                isLoading: false,
            };
        default:
        return state;
    }
}
